import { computed } from 'vue'
import { useRouter } from 'vue-router'

/**
 * Back navigation that returns to wherever the user actually came from
 * (using the router's history) instead of a hard-coded route. Falls back
 * to a sensible default when the view was opened directly (no history).
 */
export function useSmartBack(fallback: { path: string; label?: string } = { path: '/advisor' }) {
  const router = useRouter()

  const cameFrom = computed<string | null>(() => {
    const state = window.history.state as { back?: string } | null
    return state?.back || null
  })

  const backLabel = computed(() => {
    const b = cameFrom.value
    if (!b) return fallback.label || 'Back'
    if (/^\/advisor\/suppliers\/[^/]+/.test(b)) return 'Back to supplier'
    if (b.startsWith('/advisor/suppliers')) return 'Back to Supplier Directory'
    if (b.startsWith('/advisor/products')) return 'Back to Product Directory'
    if (b.startsWith('/advisor/accounts')) return 'Back to account'
    return 'Back'
  })

  function goBack() {
    if (cameFrom.value) router.back()
    else router.push(fallback.path)
  }

  return { goBack, backLabel, cameFrom }
}
